import { createContext } from "react";

import type { MayaSpaceConfig } from "../spaces";

/** The space the sidebar's chat works in (see MAYA_SPACES). */
export const MayaSpaceContext = createContext<MayaSpaceConfig | null>(null);
